<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6">
            <v-select
              label="Status"
              :items="filter.status.items"
              v-model="filter.status.value"
              item-value="id"
              item-text="text"
              :clearable="true"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field label="Email" v-model="filter.email" outlined></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-menu
              ref="startMenu"
              v-model="filter.startDate.show"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="filter.startDate.value"
              transition="scale-transition"
              min-width="290px"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.startDate.value"
                  :clearable="true"
                  label="Start Date"
                  @click:clear="filter.startDate.value = ''"
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filter.startDate.value" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="filter.startDate.show = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.startMenu.save(filter.startDate.value)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" lg="6">
            <v-row >
              <v-col class="ml-3 pa-0">
            <v-select label="Sort By" outlined v-model="page.sortBy" :items="sortFields" item-text="name" item-value="value" />
              </v-col>
              <v-col class="pa-0 ml-2">
            <v-radio-group  v-model="page.sortOrder" row>
                <v-radio label="Asc" value="asc"/>
                <v-radio label="Desc" value="desc"/>
            </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-btn class="mx-auto" large color="primary" @click="search">Search</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <hr />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="8" lg="10">Found {{page.total}} Orders</v-col>
          <v-col cols="12" md="4" lg="2">
            <v-select
              label="items per page"
              :items="page.pageSize.items"
              v-model="page.pageSize.value"
              hide-details
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-data-table
          :fixed-header="true"
          :hide-default-footer="true"
          :headers="data.headers"
          :items="data.list"
          :loading="!data.loaded"
          @click:row="gotoDetail"
        >
          <template v-slot:item.rp="{ item }">{{ item.rp | nameFormat }}</template>
          <template v-slot:item.amount="{ item }">{{ item.amount | currency }}</template>
          <template v-slot:item.actualPaid="{ item }">{{ item.actualPaid | currency }}</template>
          <template v-slot:item.discount="{ item }">{{ item.discount | currency }}</template>
          <!-- <template
            v-slot:item.courseRegistrations="{ item }"
          >{{ item.courseRegistrations | courseFormat }}</template> -->
          <template v-slot:item.status="{ item }">{{ item.status | statusFormat }}</template>
          <template v-slot:item.updatedAt="{ item }">{{ item.updatedAt | timeFormat }}</template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-pagination class="pageItem" v-model="page.pageIndex" :length="page.totalPages"></v-pagination>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      filter: {
        status: {
          value: "",
          items: [
            {
              id: "PENDING",
              text: "Pending"
            },
            {
              id: "COMPLETE",
              text: "Complete"
            }
          ]
        },
        email: "",
        startDate: {
          show: false,
          value: ""
        },
        endDate: {
          show: false,
          value: ""
        }
      },
      sortFields: [{name: 'Entry Date', value: 'id'}, {name: 'Amount Paid', value: 'actualPaid'}],
      page: {
        //分页相关
        pageSize: {
          value: 10,
          items: [10, 25, 50]
        },
        pageIndex: 1,
        total: 0,
        totalPages: 0,
        sortBy: "id",
        sortOrder: "desc"
      },
      data: {
        //table数据
        headers: [
          {
            text: "Order ID",
            value: "orderId",
            sortable: false
          },
          {
            text: "name",
            value: "rp",
            sortable: false
          },
          {
            text: "email",
            value: "rp.email",
            sortable: false
          },
          {
            text: "actualPaid",
            value: "actualPaid",
            sortable: false
          },
          {
            text: "amount",
            value: "amount",
            sortable: false
          },
          {
            text: "discount",
            value: "discount",
            sortable: false
          },
          {
            text: "status",
            value: "status",
            sortable: false
          },
          {
            text: "transactionId",
            value: "transactionId",
            sortable: false
          },
          {
            text: "updatedAt",
            value: "updatedAt",
            sortable: false
          }
        ],
        list: [],
        loaded: true
      }
    };
  },
  created() {
    this.search();
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    gotoDetail(item) {
      this.$router.push(`/secure/order/${item.orderId}`);
    },
    search() {
      if (this.page.pageIndex == 1) {
        this.getList();
      } else {
        this.page.pageIndex = 1;
      }
    },
    getList() {
      this.data.list = [];
      this.page.total = 0;
      this.page.totalPages = 0;
      this.data.loaded = false;
      let data = {
        status: this.filter.status.value,
        email: this.filter.email,
        startDate: this.filter.startDate.value,
        endDate: this.filter.endDate.value,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize.value,
        sortInfos: [{ sortCol: this.page.sortBy, sortDir: this.page.sortOrder}],
      };
      this.$axios
        .post("order/search", data)
        .then(resp => {
          this.data.list = resp.data.data.content;
          this.page.total = resp.data.data.totalElements;
          this.page.totalPages = resp.data.data.totalPages;
          this.data.loaded = true;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  },
  watch: {
    "page.pageSize.value": function() {
      this.search();
    },
    "page.pageIndex": function() {
      this.getList();
    }
  },
  filters: {
    timeFormat(value) {
      if (!value) {
        return "-";
      } else {
        return moment(value).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    statusFormat(value) {
      if (value == "PENDING") {
        return "Pending";
      } else if (value == "COMPLETE") {
        return "Complete";
      } else {
        return "-";
      }
    },
    nameFormat(value) {
      if (!value.firstName && !value.lastName) {
        return "-";
      } else {
        return `${value.firstName} ${value.lastName}`;
      }
    },
    courseFormat(value) {
      if (value && value.length > 0) {
        let courseArr = [];
        value.forEach(ele => {
          if (ele.course) {
            courseArr.push(ele.course.id);
          }
        });
        return courseArr.join(",");
      } else {
        return "-";
      }
    }
  }
};
</script>